import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      toast.error("Please complete every line.");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", { name, email, message });
      setSent(true);
      setName("");
      setEmail("");
      setMessage("");
      toast.success("Message received. Thank you.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send message.");
    } finally {
      setSending(false);
    }
  };

  const FIELD = "bg-black/40 border border-white/25 focus:border-[var(--mm-accent)] outline-none px-4 py-3 text-base text-white font-mono tracking-wide placeholder-white/45 w-full transition-colors";

  if (sent) {
    return (
      <div className="bg-black/55 backdrop-blur-sm border border-white/20 p-8 sm:p-10" data-testid="contact-success">
        <p className="text-sm sm:text-base text-white/85 leading-relaxed">
          Thank you for your message, it has been received.
        </p>
        <button
          onClick={() => setSent(false)}
          className="btn-line mt-8"
          data-testid="contact-send-another"
        >
          Send another
        </button>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      className="bg-black/55 backdrop-blur-sm border border-white/20 p-6 sm:p-8 grid gap-5"
      data-testid="contact-form"
    >
      <div>
        <label className="overline block mb-2">Name</label>
        <input
          className={FIELD}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          data-testid="contact-name"
        />
      </div>
      <div>
        <label className="overline block mb-2">Email</label>
        <input
          type="email"
          className={FIELD}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@elsewhere.com"
          data-testid="contact-email"
        />
      </div>
      <div>
        <label className="overline block mb-2">Message</label>
        <textarea
          className={`${FIELD} min-h-[140px] resize-none`}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder=""
          rows={5}
          data-testid="contact-message"
        />
      </div>
      <div className="pt-2">
        <button type="submit" className="btn-line btn-filled w-full justify-center" disabled={sending} data-testid="contact-submit">
          {sending ? "Sending…" : "Send"} <Send className="w-3.5 h-3.5" strokeWidth={1} />
        </button>
      </div>
    </form>
  );
}
